import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import ReferenzenPage from "./components/ReferenzenPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/referenzen" element={<ReferenzenPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;